import { render, staticRenderFns } from "./PriceListDialog.vue?vue&type=template&id=448e9a6e&"
import script from "./PriceListDialog.vue?vue&type=script&lang=js&"
export * from "./PriceListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports